export default "__VITE_ASSET__WnwfSCeq__"